import { Typography } from '@euler/app/components/typography';
import { ApdmImportStage } from '@euler/functions/apdm/import/importState';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ActivityIndicator, View } from 'react-native';
import { useTheme } from 'styled-components';
import { importStageLabel } from '../../functions/importStageLabel';

const kStages = [
  ApdmImportStage.Reading,
  ApdmImportStage.Recognizing,
  ApdmImportStage.Organizing,
];

/** The system works through the file by itself; nothing to do but wait. */
export function ImportProgress({ stage }: { stage: ApdmImportStage }) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  const current = kStages.indexOf(stage);
  return (
    <View accessibilityLiveRegion="polite" style={{ gap: rpx(8) }}>
      {kStages.map((entry, index) => (
        <View
          key={entry}
          style={{ flexDirection: 'row', alignItems: 'center', gap: rpx(8) }}
        >
          {index === current ? (
            <ActivityIndicator size="small" color={theme.colors.primary} />
          ) : (
            <Typography.Text
              size={rpx(14)}
              color={index < current ? theme.colors.primary : theme.label.color}
            >
              {index < current ? '✓' : '·'}
            </Typography.Text>
          )}
          <Typography.Text
            size={rpx(14)}
            bold={index === current || undefined}
            color={theme.label.color}
          >
            {importStageLabel(entry)}
          </Typography.Text>
        </View>
      ))}
      <Typography.Text size={rpx(12)} color={theme.label.color}>
        通常不到一分钟，可以先去做别的事。
      </Typography.Text>
    </View>
  );
}
